export enum ServicesStep {
    COLLECTION_DATE = 'collection_date',
    LIST = 'list',
    DROPOFFS = 'dropoffs',
}
